var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListMachineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3255 7.87549H12.6257V17.5753H22.3255V7.87549Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8752 7.87549H27.1754V17.5753H36.8752V7.87549Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3255 22.4252H12.6257V32.125H22.3255V22.4252Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8752 22.4252H27.1754V32.125H36.8752V22.4252Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1501 0.60083H5.35088C2.68343 0.60083 0.500977 2.78328 0.500977 5.45073V34.5501C0.500977 37.2176 2.68343 39.4 5.35088 39.4H44.1501C46.8175 39.4 49 37.2176 49 34.5501V5.45073C49 2.78328 46.8175 0.60083 44.1501 0.60083ZM44.1501 34.5501H5.35088V5.45073H44.1501V34.5501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListMachineIcon);
export default __webpack_public_path__ + "static/media/list-machine-icon.283c11674ea49baa3ac5d59a5439ce9e.svg";
export { ForwardRef as ReactComponent };